import { render, staticRenderFns } from "./AuthControl.vue?vue&type=template&id=77da3d7a&"
import script from "./AuthControl.vue?vue&type=script&lang=js&"
export * from "./AuthControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports